import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, Ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { AxiosResponse } from 'axios';

import { useVuelidate, Validation, ValidationArgs } from '@vuelidate/core';
import { required, maxLength } from '@/utils/validators';

import { useUiStore } from '@/stores';
import { goBack } from '@/composables/useNavigation';
import { IntegrationService } from '@/services';
import { toast, toastServiceError } from '@/services/core/notification';

import {
    FormAction,
    DefaultServiceResult,
    IntegrationServiceCreateResult,
    IntegrationType,
    OpenAiIntegrationModel,
    OpenAiIntegrationFormState,
    Permission,
} from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'OpenAiIntegrationFormPage',
  props: {
    action: {
        type: String,
        default: FormAction.CREATE,
    },
},
  setup(__props, { expose: __expose }) {
  __expose();

const uiStore = useUiStore();
const route = useRoute();

const props = __props;

const formState = reactive<OpenAiIntegrationFormState>({
    type: IntegrationType.OpenAi,
    token: null,
    model: null,
    isActive: true,
});

const rules = computed<ValidationArgs<OpenAiIntegrationFormState>>(() => ({
    type: { required },
    token: { required, maxLength: maxLength(250) },
    model: { required, maxLength: maxLength(100) },
    isActive: { required },
}));

const v$: Ref<Validation<ValidationArgs<OpenAiIntegrationFormState>>> = useVuelidate(
    rules,
    formState,
);

const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const getIntegration = async (id: number) => {
    await setLoading(true);
    try {
        const response = await IntegrationService.get<OpenAiIntegrationModel>(id);
        const { token, model, isActive } = response.data;
        formState.token = token;
        formState.model = model;
        formState.isActive = isActive;
    } catch (error) {
        toastServiceError(error);
    } finally {
        await setLoading(false);
    }
};

const onSubmit = async () => {
    const isValid = await v$.value.$validate();
    if (!isValid) return;

    await setLoading(true);

    try {
        let response: AxiosResponse<DefaultServiceResult | IntegrationServiceCreateResult>;

        if (props.action === FormAction.EDIT) {
            const id = Number(route.params.id);
            response = await IntegrationService.update<DefaultServiceResult>(id, formState);
        } else {
            response = await IntegrationService.create<IntegrationServiceCreateResult>(formState);
        }

        toast.success(response.data.message);
        v$.value.$reset();
        goBack({ name: 'ListIntegration' });
    } catch (error) {
        toastServiceError(error);
    } finally {
        await setLoading(false);
    }
};

onMounted(async () => {
    if (props.action === FormAction.EDIT) {
        await getIntegration(Number(route.params.id));
    }
});

const __returned__ = { uiStore, route, props, formState, rules, v$, setLoading, getIntegration, onSubmit, get Permission() { return Permission } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})